import React from 'react'

import { DeactivateAgentButton } from 'components/configurations/agents/DeactivateAgentButton'
import { ReactivateAgentButton } from 'components/configurations/agents/ReactivateAgentButton'
import { useAgentDetailsDrawerContext } from 'components/configurations/contexts/AgentDetailsDrawerContext'
import useAuth from 'hooks/use-auth'
import { type Agent, AgentType } from 'types/api/agents/agents'
import {
  clientsIdActivatePut,
  clientsIdDelete,
  failureFlagsAppsProtectPost,
  failureFlagsAppsUnprotectPost
} from 'utils/endpoints-access'

export const AgentDetailsDrawerButtons: React.FC<{
  agent: Agent
  isDeactivated: boolean
}> = ({ agent, isDeactivated }) => {
  const { hasEndpointAccessForAll } = useAuth()
  const { handleClose } = useAgentDetailsDrawerContext()

  const hasPrivileges =
    agent.type === AgentType.INFRASTRUCTURE
      ? hasEndpointAccessForAll([clientsIdActivatePut, clientsIdDelete], true)
      : hasEndpointAccessForAll(
          [failureFlagsAppsProtectPost, failureFlagsAppsUnprotectPost],
          true
        )

  if (!agent || !hasPrivileges) {
    return null
  }

  return isDeactivated ? (
    <ReactivateAgentButton agent={agent} onSuccess={handleClose} />
  ) : (
    <DeactivateAgentButton agent={agent} onConfirm={handleClose} />
  )
}
